import { BentoNotFound } from '@/components/bento/BentoNotFound';

export const NotFound = () => {
    return (
        <div className="container">
            <BentoNotFound />
        </div>
    );
};
